<div class="position-relative change-password text-sm">
<div class="flex-row header-wrapper">
  <h3>Change password</h3>
  <button aria-label="close dialog" class="button-close mat-mdc-icon-button">
    <mat-icon (click)="close()">close</mat-icon>
  </button>
</div>
  <div *ngIf="success" class="p-3"><div class="alert alert-success page-alert justify-content-center">
    Your password has been successfully updated.
  </div></div>

  <div>
    <mat-error class="fs-6 mx-3 mt-3" *ngIf="passwordForm.hasError('passwordMismatch')">Passwords do not match</mat-error>
    <mat-error class="fs-6 mx-3 mt-3" *ngIf="wrongOldPassword">Wrong old password</mat-error>
  </div>

  <div *ngIf="!success">
    <form [formGroup]="passwordForm"
          class="flex-column dense-5 p-3">
      <div class="flex-row">
        <div class="label">
          <label for="old_password">Old Password</label>
        </div>
      <mat-form-field class="mb-1 styled" appearance="outline">
        <input type="password" matInput formControlName="oldPassword" required placeholder="Old password*" id="old_password">
        <mat-error *ngIf="passwordForm.get('oldPassword').hasError('required')">Old Password is required</mat-error>
      </mat-form-field>
      </div>

      <div class="flex-row">
        <div class="label">
          <label for="new_password">New password</label>
        </div>
      <mat-form-field class="mb-1 styled" appearance="outline">
        <input type="password" matInput formControlName="newPassword" required placeholder="New password*" id="new_password">
        <mat-error *ngIf="passwordForm.get('newPassword').hasError('required')">New Password is required</mat-error>
      </mat-form-field>
      </div>

      <div class="flex-row">
        <div class="label">
          <label for="confirm_password">Confirm Password</label>
        </div>
      <mat-form-field class="mb-1 styled" appearance="outline">
        <input type="password" matInput formControlName="confirmPassword" required placeholder="Confirm password*" id="confirm_password">
        <mat-error *ngIf="passwordForm.get('confirmPassword').hasError('required')">Confirm Password is required
        </mat-error>
      </mat-form-field>
      </div>

      <div *ngIf="!success" class="footer-wrapper text-end">
        <button mat-stroked-button class="styled primary me-1 h-100" (click)="changePassword()"
                [disabled]="!passwordForm.valid">Update
        </button>
        <button mat-stroked-button class="styled secondary h-100" routerLink="/" (click)="close()">Cancel
        </button>
      </div>

      <div *ngIf="success" class="footer-wrapper text-end">
        <button mat-stroked-button class="styled primary me-1 h-100" (click)="close()" [disabled]="!passwordForm.valid">
          Ok
        </button>
      </div>
    </form>
  </div>
  <div *ngIf="success" class="footer-wrapper text-end">
    <button mat-stroked-button class="styled primary me-1 h-100" (click)="close()">
      Ok
    </button>
  </div>
</div>
